/**
 * @copyright Native Instruments GmbH
 */

window.players = window.players || [];

window.initContentVideos = (function ($, players) {
  return function (target) {

    function getPlayerSources(videoKey) {
        if (videoKey.substring(0, 2) === '//') {
            return [
                {
                    type: "application/vnd.apple.mpegurl",
                    src: videoKey
                }
            ];
        }

      var videoKeyIsHlsUrl = videoKey.length > 20, hlsUrl, mp4Url;
      if (videoKeyIsHlsUrl) {
        hlsUrl = videoKey.replace('https:', '');
        mp4Url = hlsUrl.replace("hls/", 'v-').replace(/\/playlist.+\.m3u8/, '.mp4');
      }
      else {
        hlsUrl = "//drive.flowplayer.org/" + videoKey + ".m3u8";
        mp4Url = "//drive.flowplayer.org/" + videoKey + ".mp4";
      }
      return [
        {
          type: "video/mp4",
          src: mp4Url
        },
        {
          type: "application/vnd.apple.mpegurl",
          src: hlsUrl
        }
      ];
    }

    target = target ? $(target) : $('*[data-video-src]');

    var playerPromises = [];
    target.responsiveLazyLoader({
      distance: 800,
      beforeLoading: function initContentVideo(element) {
        element.addClass('loaded');
        var playerPromise = Promise.all(playerPromises).then(function () {
          return new Promise(function (resolve) {
            var videoKey = element.attr('data-video-src'),
              posterImage = element.attr('data-poster-from-child') ? element.find('img').attr('src') : element.attr('data-poster-src'),
              ratioHelper = element.attr('data-video-ratio').split('/'),
              videoRatio = (parseInt(ratioHelper[0]) / parseInt(ratioHelper[1])) || (7 / 16), // default 16/7, 1920x840,
              // TODO: Fix autoplay
              videoAutoplay = element.attr('data-video-autoplay') == 'true',
              videoNoInteraction = element.attr('data-no-interaction') == 'true';

            // hide relative image
            element.parent().find('img.lazy').css('display', 'none');

            var config = {
              muted: true,
              logo: false,
              autoplay: false,
              analytics: window.googleAnalyticsProfile,
              ratio: videoRatio,
              poster: posterImage,
              tooltip: false,
              disabled: videoNoInteraction,
              clip: {
                sources: getPlayerSources(videoKey),
              },
              hlsjs: {
                safari: true
              },
            };

            var player = flowplayer(element, config)
              .on('error', function (a, b, c) {
                console.log('Flowplayer error', a, b, c)
              })
              .on('finish', function () {

                player.play();
              });

            // disable click to pause on video container
            element.find('.fp-ui').on('click', function (ev) {
              if (element.not('is-touch')) {
                if (jQuery(ev.target).hasClass('fp-ui')) {
                  ev.stopPropagation();
                }
              }
            });

            element.find('.video-control-pause').on('click', function () {
              if (element.hasClass('is-paused')) {
                player.resume();
                element.removeClass('had-user-interaction');
                nisp.hidePlayer();
                if (player.splash) {
                  player.load();
                  if (Util.isAppleMobileDevice()) {
                    element.find('.video-control-mute').addClass('ios');
                  }
                }
              } else {
                player.pause();
                element.addClass('had-user-interaction');
              }
            });

            element.find('.video-control-mute').on('click', function () {
              if (player.muted) {
                player.mute(false);
                player.volume(1);
                nisp.hidePlayer();
              } else {
                player.mute(true);
                player.volume(0);
              }
            });

            player.element = element;

            // Allow the next player instance to be loaded by resolving this promise
            player.on('ready', function () {
              players.push(player);
              $(window).scroll();
              resolve(player);
            });
          })
        });
        playerPromises.push(playerPromise);
      }
    });

    // Start different in-content-video while scrolling through the page
    $(window).on('scroll', Util.throttle(function () {
      players.forEach(function (player) {
        var belowViewport = $.belowthefold(player.element, {threshold: -200}),
          aboveViewport = $.abovethetop(player.element, {threshold: 200}),
          manualPause = player.element.hasClass('had-user-interaction');
        if (belowViewport || aboveViewport) {
          player.pause();
        } else if (!manualPause) {
          player.resume();
        }
      });
    }, 100));

    // mute video-audio when triggering sound player
    $(document).on('click', '.media-item a', function () {
      players.forEach(function (player) {
        player.mute(true);
        player.volume(0);
      });
    });
  }
})(window.jQuery, window.players);
